import React from 'react';
import classNames from 'classnames';
import { Column, useSortBy, useTable } from 'react-table';
import styles from './PartnerSummary.module.scss';
import { PartnerSummaryTablePerDevice, PartnerSummaryTablePerThreshold } from './PartnerSummaryModels';

type Props = {
    columns: Column[];
    tableData: PartnerSummaryTablePerThreshold[] | PartnerSummaryTablePerDevice[];
};

const PartnerSummaryTable = ({ columns, tableData }: Props): React.ReactElement => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
        {
            columns,
            data: tableData,
        },
        useSortBy
    );

    if (rows.length === 0) return <div />;

    return (
        <div {...getTableProps()} className={styles.table}>
            {headerGroups.map(headerGroup => {
                const { key, ...rest } = headerGroup.getHeaderGroupProps({
                    className: styles.header,
                });
                return (
                    <div key={key} {...rest}>
                        {headerGroup.headers.map(column => {
                            const { key: colKey, ...colRest } = column.getHeaderProps([
                                { className: classNames(styles.cell, column.className) },
                                column.getSortByToggleProps(),
                            ]);
                            return (
                                <div key={colKey} {...colRest}>
                                    <span>{column.render('Header')}</span>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
            <div {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row);
                    const { key: rowKey, ...rowRest } = row.getRowProps({ className: styles.row });
                    return (
                        <div key={rowKey} {...rowRest}>
                            {row.cells.map(({ getCellProps, render, column }) => {
                                const { key: cellKey, ...cellRest } = getCellProps({
                                    className: classNames(styles.cell, column.className),
                                });
                                return (
                                    <div key={cellKey} {...cellRest}>
                                        <span>{render('Cell')}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PartnerSummaryTable;
